import { FC } from 'react'
import { VStack, Box } from '@chakra-ui/react'

type Props = {
  attempts: boolean[]
}

const Attempts: FC<Props> = ({ attempts }) => {
  return (
    <VStack spacing={'2px'}>
      {[0, 1, 2].map((a, i) => {
        let color = 'black.200'
        if (attempts.length >= i + 1) {
          color = attempts[i] ? 'green.800' : 'red.700'
        }
        return (
          <Box flexShrink={0} key={i} rounded='full' w={1} h={1} bg={color} />
        )
      })}
    </VStack>
  )
}

export default Attempts
